module.exports = __webpack_public_path__ + "img/brand-22.2e31e5b9.png";